// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"50","xs":"0","sm":"576px","md":"768px","lg":"992px","xl":"1200px"};